import React from 'react'

import { SiteContext } from 'context/site-context'

import cn from 'classnames'

import Header from 'components/sections/Header'
import Footer from 'components/sections/Footer'

import TermsContent from 'components/sections/Terms'

import './index.scss'

const Terms = () => {
  const [ site ] = React.useContext(SiteContext)

  return <div className={cn('page-wrapper terms-and-conditions-container', {isLoadingSiteData: site.isLoadingSiteData} )}>
    <Header/>
    <TermsContent />
    <Footer />
  </div>
}

export default Terms
